import { render, staticRenderFns } from "./editTabLoker.vue?vue&type=template&id=876df850&scoped=true"
import script from "./editTabLoker.vue?vue&type=script&lang=js"
export * from "./editTabLoker.vue?vue&type=script&lang=js"
import style0 from "./editTabLoker.vue?vue&type=style&index=0&id=876df850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876df850",
  null
  
)

export default component.exports